import script from "./ShopCartProductDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopCartProductDetails.vue?vue&type=script&lang=ts&setup=true"

import "./ShopCartProductDetails.vue?vue&type=style&index=0&id=309c5b7a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-309c5b7a"]])

export default __exports__